/**
 * Returns a short abbreviation for a location name.
 *
 * Rules:
 *   Single-word  → first letter + last letter, both lowercase  (bar → br, kitchen → kn)
 *   Multi-word   → first letter of each word, lowercased       (Upstairs Wine Room → uwr)
 *   Single-char word → that character repeated                 (A → aa)
 *   Empty / null → "?"
 *
 * @param {string} name - Location name
 * @returns {string} Short abbreviation
 */
export function locationCode(name) {
  if (!name || typeof name !== 'string') return '?';
  const trimmed = name.trim();
  if (!trimmed) return '?';
  const words = trimmed.split(/\s+/);
  if (words.length === 1) {
    const w = words[0].toLowerCase();
    if (!w) return '?';
    if (w.length === 1) return w + w;
    return w[0] + w[w.length - 1];
  }
  return words.map((w) => (w[0] || '').toLowerCase()).join('');
}
